import React from 'react';
import { Check } from 'lucide-react';
export function AboutAuthor() {
  const credentials = ['Especialista en formación espiritual infantil', 'Más de 5 años acompañando familias en su fe', 'Mamá de 2 hijos (y sobreviviente de miles de noches sin saber qué rezar)'];
  return <section className="py-20 px-6 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-16">
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-17">
          <div className="relative w-64 h-64 md:w-80 md:h-80" data-id="element-18">
            <div className="absolute inset-0 bg-serene-blue rounded-full transform translate-x-4 translate-y-4" data-id="element-19"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7eyvLLxUsQpTW3Hh4pjJpX/Professional_warm_lifestyle_202604112128.png" alt="Autora" className="relative w-full h-full object-cover rounded-full shadow-xl border-4 border-white" data-id="element-20" />
          </div>
        </div>

        <div className="w-full md:w-1/2" data-id="element-21">
          <h2 className="font-fredoka text-3xl md:text-4xl text-charcoal mb-6" data-id="element-22">
            Hola, soy [Tu Nombre]
          </h2>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-23">
            Soy mamá de dos hijos y durante años busqué una forma de enseñarles
            a orar sin que fuera aburrido o forzado. Después de estudiar
            formación espiritual infantil y probar decenas de materiales,
            desarrollé el Método O.P.S.: el sistema que transformó la vida
            espiritual de mi familia y la de más de 1.000 hogares en Chile y
            Latinoamérica.
          </p>

          <ul className="space-y-4" data-id="element-24">
            {credentials.map((cred, index) => <li key={index} className="flex items-start gap-3" data-id="element-25">
                <div className="bg-sage-green/20 p-1 rounded-full mt-1" data-id="element-26">
                  <Check className="w-4 h-4 text-sage-green" data-id="element-27" />
                </div>
                <span className="text-charcoal font-bold text-lg" data-id="element-28">{cred}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}